{% block swag_paypal_paymemnt_action_v2_void %}
<sw-modal
    variant="small"
    :title="$t(`swag-paypal-payment.modal.title.void`)"
    @modal-close="closeModal"
>

    {% block swag_paypal_paymemnt_action_v2_void_headline %}
    <p>{{ $t('swag-paypal-payment.voidAction.confirm.message') }}</p>
    {% endblock %}

    <template #modal-footer>

        {% block swag_paypal_paymemnt_action_v2_void_cancel_button %}
        <mt-button variant="secondary" @click="closeModal">
            {{ $t('global.default.no') }}
        </mt-button>
        {% endblock %}

        {% block swag_paypal_paymemnt_action_v2_void_confirm_button %}
        <mt-button variant="primary" @click="voidPayment">
            {{ $t('swag-paypal-payment.voidAction.confirm.button.confirm') }}
        </mt-button>
        {% endblock %}

    </template>

    <sw-loader v-if="isLoading" size="43px" />
</sw-modal>
{% endblock %}
